<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/threeCard'}">应知卡</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.key ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="120px"
                    class="demo-ruleForm"
                    size="small"
                    style="width:60%;margin:0 auto"
            >
                <el-form-item label="名称" prop="name">
                    <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="编号" prop="number">
                    <el-input v-model="ruleForm.number"/>
                </el-form-item>
                <el-form-item label="部门/岗位" prop="value">
                    <el-cascader v-model="ruleForm.value" :options="options" @change="handleChange"
                                 style="width: 100%"/>
                </el-form-item>
                <el-form-item label="主要有害因素" prop="primaryHarmfulFactor">
                    <el-input v-model="ruleForm.primaryHarmfulFactor" type="textarea" :rows="3"/>
                </el-form-item>
                <el-form-item label="易导致事故风险" prop="accidentLiability">
                    <el-input v-model="ruleForm.accidentLiability" type="textarea" :rows="3"/>
                </el-form-item>
                <el-form-item label="风险等级" prop="riskLevel">
                    <el-select v-model="ruleForm.riskLevel" placeholder="请选择" style="width: 100%">
                        <el-option v-for="item in riskLevelArr" :key="item.value" :label="item.label"
                                   :value="item.value"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="风险管控措施" prop="riskControlMeasures">
                    <el-input v-model="ruleForm.riskControlMeasures" type="textarea" :rows="3"/>
                </el-form-item>
                <el-form-item label="应急处置对策" prop="emergencyProcessing">
                    <el-input v-model="ruleForm.emergencyProcessing" type="textarea" :rows="3"/>
                </el-form-item>
                <el-form-item label="安全指示标志" prop="safetyWarningLabel">
                    <el-select v-model="ruleForm.safetyWarningLabel" placeholder="请选择" style="width: 100%">
                        <el-option v-for="item in saftyArr" :key="item.value" :label="item.label" :value="item.value"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="附件">
                    <el-upload
                            class="upload-demo"
                            action="/v1/lawsRegulations/uploadFile"
                            :on-remove="handleRemove"
                            :limit="1"
                            :on-change="uploadChange"
                            :on-exceed="handleExceed"
                            :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <el-button type="primary" class="addBtn" @click="submitForm('ruleForm')">确定</el-button>
        </div>
    </div>
</template>

<script>
    import {addShouldKonwn, updateShouldKnown} from "@/api/processManager";

    export default {
        data() {
            return {
                isAdd: true,
                ruleForm: {
                    name: "",
                    content: "",
                    value: ""
                },
                rules: {
                    name: [{required: true, message: "请输入名称", trigger: "blur"}],
                    number: [{required: true, message: "请输入编号", trigger: "blur"}],
                    value: [{required: true, message: "请选择岗位", trigger: "blur"}],
                    primaryHarmfulFactor: [{required: true, message: "请输入", trigger: "blur"}],
                    accidentLiability: [{required: true, message: "请输入", trigger: "blur"}],
                    riskLevel: [{required: true, message: "请选择", trigger: "blur"}],
                    riskControlMeasures: [{required: true, message: "请输入", trigger: "blur"}],
                    emergencyProcessing: [{required: true, message: "请输入", trigger: "blur"}],
                    safetyWarningLabel: [{required: true, message: "请选择", trigger: "blur"}],
                },
                options: [],
                getObj: {},
                // 风险等级数组
                riskLevelArr: [
                    {label: "一级", value: 1},
                    {label: "二级", value: 2},
                    {label: "三级", value: 3},
                    {label: "四级", value: 4}
                ],
                // 安全指示标示数组
                saftyArr: [
                    {label: '指示标志', value: 1},
                    {label: '警示作业安全警示标志', value: 2},
                    {label: '逃生避难警示标志', value: 3},
                    {label: '风向警示标志', value: 4},
                ],
                fileList: []
            };
        },
        methods: {
            handleChange(value) {
                this.ruleForm.depId = value[0]
                this.ruleForm.jobId = value[1]
            },
            //获取部门 信息
            getAllEmpInfo() {
                this.componentsMoudel.httpRequest
                    .getRequestHander(this.componentsMoudel.getData("urls").getAllEmplotee)
                    .openLoad()
                    .startGet()
                    .then(res => {
                        res.body.data.forEach(item => {
                            let obj = {value: item.id, label: item.name, children: []};
                            item.jobVos.forEach((items, indexs) => {
                                let newObj = {value: items.id, label: items.name};
                                obj.children.push(newObj);
                            });
                            this.options.push(obj);
                        });
                    });
            },
            // 上传的事件
            handleRemove(file, fileList) {
                this.fileList = fileList;
            },
            uploadChange(file, fileList) {
                this.fileList = fileList;
            },
            handleExceed(file, fileList) {
                this.$message.warning('限制上传单个文件');
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let obj = {...this.ruleForm};
                        delete obj.value
                        if (this.fileList.length !== 0) {
                            obj.fileName = this.fileList[0].name
                            obj.fileUrl = this.fileList[0].response.data
                        } else {
                            obj.fileName = ''
                            obj.fileUrl = ''
                        }
                        if (this.isAdd) {
                            addShouldKonwn({...obj}).then(res => {
                                this.$message({
                                    showClose: true,
                                    message: "添加成功",
                                    type: "success"
                                });
                                this.$router.push({
                                    path: "/processManager/threeCard"
                                });
                            })
                        } else {
                            updateShouldKnown({...obj}).then(res => {
                                this.$message({
                                    showClose: true,
                                    message: "更新成功",
                                    type: "success"
                                });
                                this.$router.push({
                                    path: "/processManager/threeCard"
                                });
                            })
                        }
                    } else {
                        // console.log("error submit!!");
                        return false;
                    }
                });
            }
        },
        created() {
            this.getAllEmpInfo();
            let obj = this.$route.params.key;
            if (this.$route.params.key) {
                this.isAdd = false;
                this.getObj = obj;
                this.ruleForm = {
                    id: obj.id,
                    name: obj.name,
                    number: obj.number,
                    primaryHarmfulFactor: obj.primaryHarmfulFactor,
                    accidentLiability: obj.accidentLiability,
                    riskLevel: obj.riskLevel,
                    riskControlMeasures: obj.riskControlMeasures,
                    emergencyProcessing: obj.emergencyProcessing,
                    safetyWarningLabel: obj.safetyWarningLabel,
                    depId: obj.depId,
                    jobId: obj.jobId,
                    fileName: obj.fileName,
                    fileUrl: obj.fileUrl
                };
                if (obj.fileUrl) {
                    this.fileList.push({
                        name: obj.fileName,
                        response: {data: obj.fileUrl}
                    })
                }
                if (obj.departmentVo) {
                    this.$set(this.ruleForm, "value", [obj.departmentVo.id, obj.jobId]);
                }
            } else {
                this.ruleForm = {};
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    };
</script>

<style scoped>
    .addBtn {
        display: block;
        width: 300px;
        margin: 0 auto;
    }

    .myHead {
        position: absolute;
        top: 0px;
        left: 250px;
        width: 80%;
        height: 160px;
    }
</style>
